

export default {
    nombre:"",
    url_img:"https://reponerya-prod-public.s3.amazonaws.com/iconos_tilsen/LoginTilsen.png"
}